import { PayloadAction } from '@reduxjs/toolkit';

import { IServiceabilityResult } from '@/apiCalls/fetchServicing';
import { EMatchingEngineLenders } from '@/partners/matchingEngineEnums';

import { EDisplays, EJourneys, EModals, IDisplaySlice } from '../types';

import { glassGuideReducers } from './glassGuideReducers';
import { partnerReducers } from './partnerReducers';

export interface DisplayReducers {
    [key: string]: (state: IDisplaySlice, action: PayloadAction<any>) => void;
}

export const displayReducers: DisplayReducers = {
    setTestDriveAgreement: (
        state,
        action: PayloadAction<{
            testDriveAgreement: string;
        }>
    ) => {
        state.partner.testDriveAgreement = action.payload.testDriveAgreement;
    },
    setShowScanwarePopup: (state, action: PayloadAction<boolean>) => {
        state.showScanwarePopup = action.payload;
    },
    setScanwareQrId: (state, action: PayloadAction<string>) => {
        state.scanwareQrId = action.payload;
    },
    setDisplay: (state, action: PayloadAction<EDisplays>) => {
        state.previousDisplay = state.display;
        state.display = action.payload;
    },
    setIsAssetAndLiabilitiesSubmitSkipped: (
        state,
        action: PayloadAction<boolean>
    ) => {
        state.isAssetAndLiabilitiesSubmitSkipped = action.payload;
    },
    setPreviousDisplay: (
        state,
        action: PayloadAction<EDisplays | undefined>
    ) => {
        state.previousDisplay = action.payload;
    },
    setModal: (state, action: PayloadAction<EModals | null>) => {
        state.modal = action.payload;
    },

    setStockIntegrationAction: (
        state,
        action: PayloadAction<string | undefined>
    ) => {
        state.stockIntegration = action.payload;
    },

    setIsLoaded: (state, action: PayloadAction<boolean>) => {
        state.isLoaded = action.payload;
    },
    setSendLeadEmail: (state, action: PayloadAction<boolean>) => {
        state.sendLeadEmail = action.payload;
    },
    setMakeSpecificLenders: (
        state,
        action: PayloadAction<
            {
                make: string;
                tierLenders: {
                    lenders: EMatchingEngineLenders[];
                    showLenderDetails: boolean;
                }[];
            }[]
        >
    ) => {
        state.makeSpecificLenders = action.payload;
    },
    setIllionCodes: (
        state,
        action: PayloadAction<{
            threeMonths: string;
            sixMonths: string;
            twelveMonths: string;
        }>
    ) => {
        state.illionCodes = action.payload;
    },
    setInitialJourney: (state, action: PayloadAction<string>) => {
        state.initialJourney = action.payload as EJourneys;
    },
    setVehicleManualEntry: (state, action: PayloadAction<boolean>) => {
        state.vehicleManualEntry = action.payload;
    },
    setIsPriceKnownViaExternal: (state, action: PayloadAction<boolean>) => {
        state.isPriceKnownViaExternal = action.payload;
    },
    setNovatedCost: (
        state,
        action: PayloadAction<{
            medicare: number;
            taxPayable: number;
            monthlySaving: number;
            annualSaving: number;
            termSaving: number;
            novated: {
                financeOnly: number;
                fullyMaintained: number;
                annualSaving: number;
                fuel: number;
                registration: number;
                maintenanceRepairs: number;
                tyres: number;
                insurance: number;
                adminFee: number;
                totalLeaseRentalExGST: number;
                preTaxDeduction: number;
                postTaxDeduction: number;
            };
            consumer: {
                financeOnly: number;
                fullyMaintained: number;
                annualSaving: number;
                fuel: number;
                registration: number;
                maintenanceRepairs: number;
                tyres: number;
                insurance: number;
                adminFee: number;
                totalLeaseRentalExGST: number;
                preTaxDeduction: number;
                postTaxDeduction: number;
            };
        }>
    ) => {
        state.novatedCost = action.payload;
    },
    setSmsRequestAttempts: (state, action: PayloadAction<number>) => {
        state.smsRequestAttempts = action.payload;
        localStorage.setItem('smsRequestAttempts', action.payload.toString());
    },
    setSmsLastRequestTimestamp: (state, action: PayloadAction<Date | null>) => {
        state.smsLastRequestTimestamp = action.payload;
        if (action.payload) {
            localStorage.setItem(
                'smsLastRequestTimestamp',
                action.payload.getTime().toString()
            );
        } else {
            localStorage.removeItem('smsLastRequestTimestamp');
        }
    },
    setServiceabilityResult: (
        state,
        action: PayloadAction<IServiceabilityResult>
    ) => {
        state.serviceabilityResult = action.payload;
    },
    ...partnerReducers,
    ...glassGuideReducers,
};
